// removed by extract-text-webpack-plugin
module.exports = {"errorMessage":"errorMessage__errorMessage--k54ik","slideInY":"errorMessage__slideInY--2EwLi","errorIcon":"errorMessage__errorIcon--1SMuT"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/UI_Elements/errorMessage.css
// module id = 0xmR
// module chunks = 47